import { Button, Flexbox, Icons, Label, Text } from "@sede-x/shell-ds-react-framework";
import { format } from "date-fns";
import { usePicklists } from "ticketing/contexts/picklists/PicklistContextProvider";
import { TLinkedTicket, TMovementGroup, TTicket, TVolume } from "ticketing/ticketing.types";
import { formatNumber } from "ticketing/utils";
import "./movements.css";
import { findMatchingVolume } from "./volume_util";

export const LinkedTicket = ({
  activeMovementGroup,
  ticket,
  disableLinks,
  onShowTicketRevisions,
  onUnlinkTicket,
  onEditTicket,
  showDocument
}: {
  activeMovementGroup?: TMovementGroup | null;
  ticket: TLinkedTicket;
  disableLinks: boolean;
  onShowTicketRevisions: (ticketId: string) => void;
  onUnlinkTicket: (ticket: TLinkedTicket) => void;
  onEditTicket: (ticket: TTicket) => void;
  showDocument: (documentId: string) => void;
}) => {
  const { picklists } = usePicklists();
  const matchingVolume: TVolume = findMatchingVolume(
    ticket,
    activeMovementGroup,
    picklists?.uomConversions
  );

  return (
    <div style={{ padding: "4px" }}>
      <div className="ticket-component">
        <div className="ticket-component-outter">
          <Flexbox flexWrap="wrap" gap="2px">
            <Flexbox flexWrap="nowrap" gap="2px">
              <Text
                style={{ color: "#09B0EC", fontSize: "12px" }}>{`${ticket.ticketNumber}`}</Text>
              {!!ticket.documentId && (
                <Button
                  icon={<Icons.FilePdfOutline style={{ fill: "limegreen" }} />}
                  onClick={() => showDocument(ticket.documentId!)}
                  title={ticket.document?.fileName ?? "Ticket has document attached"}
                  className="document-icon-button"
                />
              )}
            </Flexbox>
            <Text style={{ fontSize: "12px" }}>
              {ticket?.startDate
                ? `(${format(new Date(ticket.startDate), "yyyy-MM-dd")})`
                : "(No date)"}
            </Text>
          </Flexbox>
          <Flexbox gap="2px">
            <Button
              disabled={disableLinks}
              icon={
                <Icons.EditOutlined style={{ fill: `${disableLinks ? "gray" : "#ff6358"}` }} />
              }
              title="Edit Ticket"
              onClick={() => onEditTicket(ticket)}
              className="linked-ticket-button"></Button>
            <Button
              title="Ticket Revisions"
              onClick={() => onShowTicketRevisions(ticket.id)}
              icon={<Icons.Time style={{ fill: "var(--primary-icon-color)" }} />}
              className="linked-ticket-button"></Button>
            <Button
              title="Unlink Ticket"
              icon={<Icons.CrossCircle style={{ fill: "#ff6358" }} />}
              disabled={disableLinks}
              onClick={() => onUnlinkTicket(ticket)}
              className="linked-ticket-button"></Button>
          </Flexbox>
        </div>
        <div className="ticket-component-label-wrapper">
          <Label size="small">{`Net:${formatNumber(matchingVolume?.netVolume ?? 0.0)}`}</Label>
          <Label size="small">{`Gross:${formatNumber(
            matchingVolume?.grossVolume ?? 0.0
          )}`}</Label>
          <Label size="small">{matchingVolume?.unitOfMeasure?.name}</Label>
          <Label size="small">{`${
            matchingVolume?.temperature
          }${matchingVolume?.temperatureUnitOfMeasure?.charAt(0)}`}</Label>
        </div>
      </div>
    </div>
  );
};
